import * as React from "react";
import { useState, useEffect } from "react";
import BAVButton from "./BAVButton";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import HandymanIcon from '@mui/icons-material/Handyman';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { Grid, Box, Typography } from '@mui/material';
import { getUserToken } from "../utils/AuthTokenReader.jsx";


function BAVAdminButton(props) {
    const { rowData, showSnackbarFunc } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [inputValue, setInputValue] = React.useState("");
    const [inputError, setInputError] = React.useState(false);
    const [newPfNumber, setNewPfNumber] = React.useState("");
    const [entryDetail, setEntryDetail] = React.useState(null);
    const [remark, setRemark] = React.useState("");
    const open = Boolean(anchorEl);
    const [openDlgPfNr, setOpenDlgPfNr] = React.useState(false);
    const [openDlgBemerkung, setOpenDlgBemerkung] = React.useState(false);


    // Auth Token
    const [options, setOptions] = useState();
    const [token, setToken] = useState();
    const initToken = async () => {
        const ltoken = await getUserToken();
        setToken(ltoken);
        const headers = new Headers();
        const bearer = `Bearer ${ltoken.accessToken}`;
        headers.append("Authorization", bearer);
        headers.append("Content-Type", "application/json");
        setOptions({ headers: headers });
    };
    const reInitToken = new Promise((resolve, reject) => {
        if (token && token.expiresOn < Date.now()) {
            initToken()
                .then((res) => {
                    resolve('initToken');
                })
        } else {
            resolve('tokenValid');
        }
    });
    useEffect(() => {
        initToken();
    }, []);

    

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickOpenDlg = () => {
        setOpenDlgPfNr(true);
    };

    const handleCloseDlgPfNr = () => {
        setInputValue("");
        setInputError(false);
        setNewPfNumber("");
        setOpenDlgPfNr(false);
    };

    const handleOpenDlgBemerkung = () => {
        fetch("/profileform/remarks/" + rowData.entryId, options)
            .then(function (result) {
                if (result.status !== 204) {
                    return result.json();
                }// Warte auf die Auflösung der Promise
            })
            .then(function (obj) {
                setEntryDetail(obj);
                setRemark(obj?obj.value_1:null);
                setOpenDlgBemerkung(true);
            })

           

    }
    const handleCloseDlgBemerkung = () => {
        setOpenDlgBemerkung(false);
        setEntryDetail(null);
        setRemark("");
    }
    // is valid function to check value is valid 
    const isValidInput = (value) => {
        var ret;
        return (isNaN(value) == false && value > 0 && value < 100 && value.length <= 2) || !value 
    };
    // change function to set value to text field on change
    const handleInputChange = (event) => {
        const inputValue = event.target.value;

        if (isValidInput(inputValue)) {
            setInputValue(inputValue);
        }
        // nun Korrektheit validieren
        (10, 10),
            (30, 45),
            (70, 75)
        if (!inputValue || inputValue < 10 || inputValue > 10 && inputValue < 30 || inputValue > 45 && inputValue < 70 || inputValue > 75) {
            setInputError(true);
            setNewPfNumber("");
            
        } else {
            setInputError(false);
            setNewPfNumber(rowData.editKtGnr.substring(0, rowData.editKtGnr.length - 2) + inputValue);
        }
    };

    function handleChangePfNumber (event) {
        var putData = {
            portfolioId: rowData.portfolioId,
            newPfNumber: inputValue
        }
        try {
            var ret = updatePortfolio(putData);
            handleCloseDlgPfNr();
        } catch (err ) {
            console.log(err);

        }
        
    }

    function handleChangeBemerkung(data) {
       
        var questionId, responseId;
        switch (rowData.entryType){
            case 2:
                questionId = 21;
                responseId = 126;
                break;
            case 3:
                questionId = 32;
                responseId = 125;
                break;
            case 4:
                questionId = 40;
                responseId = 158;
                break;
        }
        if (entryDetail) {
            entryDetail.value_1 = remark;
            setEntryDetail(entryDetail);   
            try {
                var ret = updateRemark(entryDetail);
                handleCloseDlgBemerkung();
            } catch (err) {
                console.log(err);

            }   
        } else {
            var postData = {
                entryId: rowData.entryId,
                entryDetailType: rowData.entryType,
                questionId: questionId,
                responseId: responseId,
                value_1: remark,
                value_2: 'Durch Team Investment Solutions hinzugefügte Bemerkungen'
            }
            try {
                var ret = createRemark(postData);
                handleCloseDlgBemerkung();
            } catch (err) {
                console.log(err);

            }
        }
    }
    function handleDelete() {
        if (!window.confirm("Möchten Sie die Profilierung mit der ID " + rowData.entryId + " wirklich löschen?")) {
            return;
        }
        let requestOptions = {
            method: "DELETE",
            headers: options.headers,
            body: JSON.stringify(rowData.entryId),
        };
        reInitToken
            .then((res) => {
                fetch("/entries/" + rowData.entryId, requestOptions)
                    .then(function (result) {
                        if (result.status !== 204) {
                            //alert("Profilierung konnte nicht gelöscht werden");
                            showSnackbarFunc('Profilierung konnte nicht gelöscht werden.', 'error');
                            //setSnackbarMessage("Profilierung konnte nicht gelöscht werden.");
                            //setSnackbarBgColor("red");
                            //setOpenSnackbar(true);
                            return;
                        } else {
                            //alert("Profilierung mit der ID " + props.rowData.entryId + " wurde gelöscht");
                            showSnackbarFunc('Profilierung mit der ID ' + rowData.entryId + ' wurde gelöscht.', 'info');
                            //setSnackbarMessage("Profilierung mit der ID " + rowData.entryId + " wurde gelöscht.");
                            //setSnackbarBgColor("#1976d2");
                            //setOpenSnackbar(true);
                        }
                    });
            });

    }

    function updatePortfolio(putData) {
        let requestOptions = {
            method: "PUT",
            headers: options.headers,
            body: JSON.stringify(putData.newPfNumber),
        };
        reInitToken
            .then((res) => {
                fetch("/portfolios/pfChangeNumber/" + putData.portfolioId, requestOptions)
                    .then(function (response) {
                        if (!response.ok) {
                            //throw Error(response.statusText)
                            return response.json().then((error) => {
                                throw Error(error.detail || response.statusText);
                            });
                        }
                        showSnackbarFunc('Portfolionummer wurde erfolgreich geändert.', 'info');
                        //setSnackbarMessage("Portfolionummer wurde erfolgreich geändert.");
                        //setSnackbarBgColor("#1976d2");
                        //setOpenSnackbar(true);
                    })
                    .catch((error) => {
                        // Handle the error
                        showSnackbarFunc('Portfolionummer konnte nicht geändert werden.', 'error');
                        //setSnackbarMessage(error.message);
                        //setSnackbarBgColor("red");
                        //setOpenSnackbar(true);
                    });
            });


    }
    function changeRemark(data) {
        setRemark(data.target.value);
    }

    function createRemark(postData) {
        let requestOptions = {
            method: "POST",
            headers: options.headers,
            body: JSON.stringify(postData),
        };
        reInitToken
            .then((res) => {
                fetch("/entrydetails/", requestOptions)
                    .then(function (response) {
                        if (!response.ok) {
                            //throw Error(response.statusText)
                            return response.json().then((error) => {
                                throw Error(error.detail || response.statusText);
                            });
                        }
                        showSnackbarFunc('Bemerkung wurde erfolgreich hinzufgeügt.', 'info');
                    })
                    .catch((error) => {
                        // Handle the error
                        showSnackbarFunc('Bemerkung konnte nicht hinzugefügt werden.', 'error');
                    });
            });
    }

    function updateRemark(entryDet) {
        let requestOptions = {
            method: "PUT",
            headers: options.headers,
            body: JSON.stringify(entryDet),
        };
        
        reInitToken
            .then((res) => {
                fetch("/entrydetails/" + entryDetail.entryDetailId, requestOptions)
                    .then(function (response) {
                        if (!response.ok) {
                            //throw Error(response.statusText)
                            return response.json().then((error) => {
                                throw Error(error.detail || response.statusText);
                            });
                        }
                        showSnackbarFunc('Bemerkung wurde erfolgreich angepasst.', 'info');
                    })
                    .catch((error) => {
                        // Handle the error
                        showSnackbarFunc('Bemerkung konnte nicht angepasst werden.', 'error');
                    });
            });
    }

    return(
        <>
            <BAVButton
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            className="m-1"
            variant="contained"
            title="Admin Funktionen"
            startIcon={<HandymanIcon />}
            style={{
                maxWidth: "30px",
                maxHeight: "20px",
                minWidth: "30px",
                minHeight: "20px",
                fontSize: "0.75rem",
                color: 'rgba(0, 0, 200, 0.6)'
                }}>
         </BAVButton>
            <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            >

                <MenuItem sx={{ fontSize: 12 }} onClick={function (event) { handleClose(); handleDelete(); }}>Löschen</MenuItem>
                <MenuItem sx={{ fontSize: 12 }} onClick={function (event) { handleClose(); setOpenDlgPfNr(true); }}>Pf-Nummer ändern</MenuItem>
                <MenuItem sx={{ fontSize: 12 }} onClick={function (event) { handleClose(); handleOpenDlgBemerkung(); }}>Bemerkung hinzufügen</MenuItem>
            </Menu>
            <Dialog
                open={openDlgPfNr}
                onClose={handleCloseDlgPfNr}
                slotProps={{
                    paper: {
                        component: 'form',
                        onSubmit: (event) => {
                            event.preventDefault();
                            handleClose();
                        },
                    },
                }}
            >
                <DialogTitle>Portfolio Nummer ändern</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Die aktuelle Portfolionummer lautet: <b>{rowData.editKtGnr}</b> <br></br>
                        Auf welchen Wert möchten Sie diese ändern (letzte zwei Stellen)?
                    </DialogContentText>
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Box p={2}>
                            <TextField
                        hiddenLabel
                        autoFocus
                        id="newPfAddNumber"
                        size="small"
                        style={{ width: 140 }}
                        error={inputError}
                        helperText={inputError && inputValue.length ==2 ? "Zahl nicht im erlaubten Bereich." : ""}
                        onChange={handleInputChange}
                        value={inputValue}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={8}>
                            <Box p={2} display="flex"  height="100%" >
                                {newPfNumber && (
                                    <Typography variant="inherit" style={{ fontWeight: 500 }}>
                                        <span style={{ fontWeight: 300 }}>Neue Portfolionummer: </span>
                                        {newPfNumber}
                                    </Typography>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <BAVButton onClick={handleCloseDlgPfNr} variant="contained">Abbrechen</BAVButton>
                    <BAVButton disabled={inputError} onClick={handleChangePfNumber } variant="contained">Aendern</BAVButton>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDlgBemerkung}
                onClose={handleCloseDlgBemerkung}
                slotProps={{
                    paper: {
                        component: 'form',
                        onSubmit: (event) => {
                            event.preventDefault();
                            handleClose();
                        },
                    },
                }}
            >
                <DialogTitle>Bemerkung hinzufügen</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                     
                    </DialogContentText>
                    <Typography variant="body1" ml={0} mt={1}>
                        <textarea
                            rows={4}
                            cols={60}
                            style={{ marginTop: "10px", marginLeft: "12px" }}
                            value={remark}
                            onChange={(e) => changeRemark(e)}
                        ></textarea>
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <BAVButton onClick={handleCloseDlgBemerkung} variant="contained">Abbrechen</BAVButton>
                    <BAVButton disabled={inputError} onClick={handleChangeBemerkung} variant="contained">Hinzufügen</BAVButton>
                </DialogActions>
            </Dialog>
         </>
    )
}
export default BAVAdminButton;